export default __webpack_public_path__ + "images/f0f9d9ba01000379afc0389d9fe21fcf.svg";